// require('jquery');
window.$ = window.jQuery = require("../../node_modules/jquery/dist/jquery.js");

// require('angular');

// import angular from '../../node_modules/angular/angular.min.js';
// import '../../node_modules/ng-infinite-scroll/build/ng-infinite-scroll.js';

// import from '../../node_modules/ng-infinite-scroll/build/ng-infinite-scroll.js';
// angular.infiniteScroller =
// require('../../node_modules/ng-infinite-scroll/build/ng-infinite-scroll.js');

window.Headroom = require("../../node_modules/headroom.js/dist/headroom.min.js");
require("imports-loader?window.jQuery=jquery!../../node_modules/headroom.js/dist/jQuery.headroom.min.js");
require("imports-loader?$=jquery!../../node_modules/bootstrap/dist/js/bootstrap.min.js");
require("imports-loader?$=jquery!../../node_modules/owl.carousel/dist/owl.carousel.js");

// import '../../node_modules/sweetalert2/dist/sweetalert2.js';
window.Swal = require("../../node_modules/sweetalert2/dist/sweetalert2.js");
window.LazyLoad = require("../../node_modules/vanilla-lazyload/dist/lazyload.min.js");
require("imports-loader!../../node_modules/isotope-layout/dist/isotope.pkgd.min.js");

require("../../node_modules/jsrender/jsrender.min.js");
import "../../node_modules/jquery-scrollify/jquery.scrollify.js";

// import '../../node_modules/@fortawesome/fontawesome-pro/js/all.js';
import "../../node_modules/@fortawesome/fontawesome-pro/js/fontawesome.js";

global.MobileDetect = require("imports-loader?$=jquery!../../node_modules/mobile-detect/mobile-detect.js");

// window.FontAwesomeConfig = {
//   searchPseudoElements: true
// };
// require('../vendor/fontawesome-free/svg-with-js/js/fontawesome-all.js');
